module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/3.1-a90432a5909c85e9af0e0140fec05f61.png";